import React from "react";
import { Props } from "./types";

const rootStyle = () => ({
  backgroundColor: "#ebecee",
  borderRadius: "5px",
  padding: "1em"
});

const gridStyle = () => ({
  width: "fit-content",
  display: "grid",
  gridGap: "1em"
});

const itemStyle = () => ({
  gridRow: 1
});

const Nav = (props: { array: Props }) => {
  const items = props.array.map(item => (
    <a style={itemStyle()} key={item.text + item.link} href={item.link}>
      {item.text}
    </a>
  ));
  return (
    <div id="nav" style={rootStyle()}>
      <div style={gridStyle()}>{items}</div>
    </div>
  );
};

export default Nav;
